var _style, _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _ellipse2, _path7, _path8, _path9, _path10, _rect, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path11, _path12, _path13, _path14, _path15, _ellipse7, _path16, _rect2, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _rect3, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _path44, _path45, _path46, _path47, _path48, _ellipse21, _path49, _path50, _path51, _path52, _rect4, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _path53, _path54, _path55, _path56, _path57, _ellipse26, _path58, _path59, _path60, _path61, _rect5, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _path62, _path63, _path64, _path65, _path66, _ellipse31, _path67, _path68, _path69, _path70, _path71, _path72, _ellipse32, _path73, _path74, _path75, _ellipse33, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _rect6, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _path101, _path102;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarthMaulHilt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 400",
    style: {
      enableBackground: "new 0 0 35 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0dmh{fill:#6C6C6B;}\r\n\t.st1dmh{fill:#757575;}\r\n\t.st2dmh{fill:#777777;}\r\n\t.st3dmh{fill:#888989;}\r\n\t.st4dmh{fill:#7C7C7B;}\r\n\t.st5dmh{fill:#878787;}\r\n\t.st6dmh{fill:#909090;}\r\n\t.st7dmh{fill:#949797;}\r\n\t.st8dmh{fill:#1F2122;}\r\n\t.st9dmh{fill:#989999;}\r\n\t.st10dmh{fill:#828282;}\r\n\t.st11dmh{fill:#747575;}\r\n\t.st12dmh{fill:#891919;}\r\n\t.st13dmh{fill:#9A191C;}\r\n\t.st14dmh{fill:#1E2021;}\r\n\t.st15dmh{fill:#5E5F5E;}\r\n\t.st16dmh{fill:#4A494A;}\r\n\t.st17dmh{fill:#6D6D6D;}\r\n\t.st18dmh{fill:#272827;}\r\n\t.st19dmh{fill:#202223;}\r\n\t.st20dmh{fill:#939797;}\r\n\t.st21dmh{fill:#8F9393;}\r\n\t.st22dmh{fill:#212323;}\r\n\t.st23dmh{fill:#1E1E1E;}\r\n\t.st24dmh{fill:#222323;}\r\n\t.st25dmh{fill:#6B7070;}\r\n\t.st26dmh{fill:#7F7F80;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0dmh",
    d: "M34.4,388c0.1,0.8,0.2,2.6-0.6,4.6c-0.6,1.5-1.5,2.4-2,2.9c-1.8,1.3-7.7,5.3-15.7,4.4c-5.3-0.6-9.2-3-11.1-4.4 c-0.3-0.2-1.2-0.9-1.6-2.3C3,392,3.2,391,3.2,390.5c1.1,0.9,2.8,2.2,5,3.2c4.2,1.9,7.9,1.9,10.1,1.9c3.4-0.1,7.9-0.1,12.2-3.4 C32.4,390.7,33.6,389.1,34.4,388z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1dmh",
    d: "M34.6,385c0.1,0.8,0.1,2.5-0.7,4.3c-0.6,1.5-1.5,2.4-2,2.9c-1.8,1.3-7.8,5.3-16,4.4c-5.4-0.6-9.4-3-11.3-4.4 c-0.3-0.2-1.2-0.9-1.6-2.3c-0.4-1.2-0.3-2.2-0.2-2.6c1.2,0.9,2.9,2.2,5.1,3.2c4.3,1.9,8,1.9,10.3,1.9c3.1-0.1,7.8-0.2,12.4-3.4 C32.5,387.5,33.8,386,34.6,385z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2dmh",
    d: "M34.7,380.3c0.2,0.6,0.7,2.8-0.2,5.2c-0.6,1.5-1.6,2.5-2.1,2.9c-1.9,1.3-8.2,5.3-16.6,4.4 c-5.6-0.6-9.7-3-11.8-4.4c-0.6-0.4-1.3-1.1-1.7-2.3c-0.7-2,0.1-4.1,0.4-4.8c0.9,1.4,2.5,3.4,4.9,5c3.5,2.2,6.7,2.2,10.4,2.2 c4.4,0,9,0,12.9-3.4C32.8,383.5,34,381.6,34.7,380.3z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3dmh",
    cx: 18.6,
    cy: 380.1,
    rx: 16.1,
    ry: 8.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "stdmh4",
    d: "M30.4,379c0,0.5,0.1,1.7-0.5,2.9c-0.4,1-1.1,1.6-1.5,2c-1.3,0.9-5.7,3.6-11.6,3c-3.9-0.4-6.8-2-8.2-3 c-0.2-0.2-0.9-0.6-1.2-1.5c-0.3-0.8-0.2-1.5-0.2-1.8c0.8,0.6,2.1,1.5,3.7,2.1c3.1,1.3,5.8,1.3,7.4,1.3c2.2,0,5.7-0.1,9-2.3 C28.8,380.7,29.8,379.7,30.4,379z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5dmh",
    d: "M30.4,375.8c0.1,0.4,0.5,1.9-0.2,3.6c-0.4,1-1.1,1.7-1.5,2c-1.4,0.9-5.9,3.6-12,3c-4.1-0.4-7-2-8.5-3 c-0.4-0.3-0.9-0.8-1.2-1.5c-0.5-1.4,0-2.8,0.3-3.2c0.7,0.9,1.8,2.3,3.6,3.4c2.5,1.5,4.8,1.5,7.5,1.5c3.2,0,6.5,0,9.4-2.3 C29.1,378,29.9,376.7,30.4,375.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6dmh",
    d: "M30.6,373.3c0.1,0.4,0.5,1.9-0.2,3.6c-0.4,1-1.1,1.7-1.5,2c-1.4,0.9-5.9,3.6-12,3c-4.1-0.4-7-2-8.5-3 c-0.4-0.3-0.9-0.8-1.2-1.5c-0.5-1.4,0-2.8,0.3-3.2c0.7,0.9,1.8,2.3,3.6,3.4c2.5,1.5,4.8,1.5,7.5,1.5c3.2,0,6.5,0,9.4-2.3 C29.2,375.4,30.1,374.2,30.6,373.3z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3dmh",
    cx: 19,
    cy: 373.2,
    rx: 12.5,
    ry: 6.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7dmh",
    d: "M28.6,256.2H6.7v-10.6c7.2,0.1,14.5,0.1,21.7,0.2C28.4,249.3,28.5,252.7,28.6,256.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7dmh",
    d: "M28.6,292.2H7.1v-12.1c0.5,0.2,1.1,0.5,2,0.8c1.4,0.5,3.1,0.9,8.3,0.9c5.6,0,7.4-0.4,8.3-0.7 c1.2-0.3,2.2-0.7,2.8-1C28.6,284.2,28.6,288.2,28.6,292.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8dmh",
    d: "M28.4,288.9c-0.4,0.2-1,0.5-1.8,0.8c-1,0.4-3.2,1.1-10.2,1c-3.9-0.1-5.6-0.3-7.6-1.2c-0.6-0.2-1-0.5-1.3-0.7 c-0.1,0-0.2,0-0.2,0.1c-0.2,0.2-0.1,0.6,0.1,1.1c1.2,0.7,2.4,1.4,3.6,2c2.8,0.1,5.7,0.2,8.5,0.3c2.2-0.1,4.4-0.3,6.5-0.5 c0.8-0.6,1.6-1.2,2.3-1.7c0.3-0.6,0.3-1,0.2-1.2C28.5,289,28.5,288.9,28.4,288.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7dmh",
    d: "M28.8,328c-7.2-0.1-14.5-0.2-21.7-0.3c0-12.7,0.1-25.3,0.1-38c0.6,0.4,1.5,0.9,2.6,1.4c1.5,0.6,2.9,0.8,7.3,0.8 c6.5,0,8.3-0.4,10.1-1.4c0.6-0.3,1.1-0.7,1.4-0.9C28.7,302.4,28.8,315.2,28.8,328z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.6,
    y: 300.9,
    className: "st9",
    width: 4,
    height: 8.4
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st10dmh",
    cx: 17.6,
    cy: 296.8,
    rx: 4.2,
    ry: 4.6
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11dmh",
    cx: 17.6,
    cy: 296.8,
    rx: 3.6,
    ry: 4
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st12dmh",
    cx: 18.6,
    cy: 317.6,
    rx: 5.1,
    ry: 5.3
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st13dmh",
    cx: 18.6,
    cy: 318.2,
    rx: 4.2,
    ry: 4.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st14dmh",
    d: "M7.8,302.4c0.6,0.3,1.2,0.5,1.9,0.8c0-4.2,0-8.4,0-12.6c-0.2,0-0.4,0-0.6,0c0,3.9,0,7.7,0,11.6 c-0.3-0.2-0.7-0.3-1-0.5c0-3.9,0-7.8,0.1-11.8c-0.1,0-0.2,0-0.4-0.1C7.7,294,7.7,298.2,7.8,302.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st15dmh",
    d: "M7.7,310.5c0,0.7,0.4,1.3,0.8,1.5c0.7,0.3,1.6-0.3,1.8-1.5c0.2-1.1,0.1-1.9,0-2.5c-0.3-1.1-1.1-2.3-1.1-2.3 c0,0,0,0,0,0c-0.2-0.2-0.5-0.6-0.8-0.5c-0.5,0.1-0.9,1-0.9,1.7C7.6,308.2,7.6,309.3,7.7,310.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st16dmh",
    d: "M6.7,308.3c0.4-1.1,1-1.7,1.5-1.6c0.1,0,0.2,0.1,0.4,0.4c0.1,0.2,0.6,1.1,0.4,2.2c-0.1,0.7-0.5,1.2-0.7,1.4 c-0.1,0-0.6,0-1-0.3c-0.5-0.4-0.6-0.9-0.6-1C6.7,309,6.7,308.7,6.7,308.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st15dmh",
    d: "M7.6,313.1c0.2-0.3,0.4-0.6,0.5-0.8c1.4,1.8,2,4,1.3,5.5c-0.1,0.3-0.4,0.7-0.8,1.1c-0.2-0.2-0.4-0.4-0.7-0.6 c0.2-0.5,0.4-1.2,0.4-2.2C8.4,314.6,7.9,313.6,7.6,313.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st17dmh",
    d: "M7,313.7c-0.3,0.5-0.7,1.5-0.5,2.7c0.1,0.5,0.1,1,0.5,1.4c0.4,0.4,0.9,0.4,1.1,0.4c0.2-0.5,0.5-1.2,0.6-2.1 c0.1-1.2,0-3-0.6-3.1C7.9,313,7.6,313,7,313.7z"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st18dmh",
    cx: 6.6,
    cy: 315.9,
    rx: 0.2,
    ry: 0.6
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st14dmh",
    d: "M7.9,289.3c0-1.3,0-2.6,0-3.9c0.4,0.2,0.7,0.3,1.1,0.5c0,1.4,0,2.7,0,4.1c0.2,0.1,0.4,0.1,0.6,0.2 c0-1.7,0-3.4-0.1-5.1c-0.7-0.3-1.3-0.5-2-0.8c0,1.7,0,3.3,0.1,5C7.7,289.2,7.8,289.2,7.9,289.3z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.7,
    y: 257.8,
    className: "st14dmh",
    width: 16.4,
    height: 23.8
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14dmh",
    cx: 17.7,
    cy: 271.4,
    rx: 11.4,
    ry: 1.3
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7dmh",
    cx: 17.7,
    cy: 274,
    rx: 11.4,
    ry: 1.3
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14dmh",
    cx: 17.6,
    cy: 276.6,
    rx: 11.4,
    ry: 1.3
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7dmh",
    cx: 17.8,
    cy: 279,
    rx: 11.4,
    ry: 1.3
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14dmh",
    cx: 17.4,
    cy: 261.3,
    rx: 11.4,
    ry: 1.3
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7dmh",
    cx: 17.5,
    cy: 263.7,
    rx: 11.4,
    ry: 1.3
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14dmh",
    cx: 17.4,
    cy: 266.3,
    rx: 11.4,
    ry: 1.3
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7dmh",
    cx: 17.7,
    cy: 268.7,
    rx: 11.4,
    ry: 1.3
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7dmh",
    cx: 17.2,
    cy: 259.1,
    rx: 11.4,
    ry: 1.3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st8dmh",
    d: "M6.5,253.6c0,0.1,0,0.2,0.1,0.3c0.7,2,3.9,1.9,11.5,2c6.8,0.1,9.7,0.1,10.4-1.7c0.2-0.4,0.2-0.8,0.2-1.1 c0.9,0,1.6,0.8,1.7,1.7c0.1,1-0.7,2.1-1.7,2.1c-0.6,0.3-1.5,0.7-2.7,1c-1.8,0.5-2.6,0.3-8.8,0.2c0,0-1.8,0-4.9-0.2 c-1-0.1-1.9-0.1-2.5-0.2c-1.9-0.2-2.5-0.4-3.1-0.7c-0.6-0.4-1.5-0.9-1.5-1.7C5,254.6,5.6,253.9,6.5,253.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st19dmh",
    d: "M7.3,322.9c-0.1,0.1-0.3,0.3-0.4,0.6c-0.1,0.2-0.1,0.4-0.1,0.5c0.4,0.6,0.7,1.3,1.1,1.9c2.5,0.7,5,1.5,7.5,2.2 c3-0.2,6-0.5,9-0.7c1.3-0.8,2.5-1.5,3.8-2.3c0.2-0.4,0.4-0.7,0.7-1.1c0,0,0.2-0.5,0-0.9c-0.1-0.3-0.4-0.4-0.4-0.5 c-0.7,0.5-1.7,1.3-3.1,1.9c-2.2,1-4,1-7.6,1c-3.4,0-5.2,0-7.3-0.8C9.1,324.2,8,323.4,7.3,322.9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st20dmh",
    d: "M6.8,324c0.4,0.5,1.1,1.2,2,1.9c1,0.7,2.6,1.5,8.6,1.5c5.8,0,7.4-0.7,8.2-1.1c1.5-0.7,2.5-1.6,3.2-2.3 c0.1,3.8,0.3,7.6,0.4,11.3c-0.2,1.1-0.3,2.2-0.5,3.4c-2.4,0.9-4.8,1.7-7.1,2.6c-4-0.4-7.9-0.9-11.9-1.3c-1.1-1.1-2.3-2.2-3.4-3.4 c0.1-0.3,0.2-0.7,0.3-1C6.8,331.8,6.8,327.9,6.8,324z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st19dmh",
    d: "M29.3,335.3c0,0.3-0.1,0.6-0.2,1c-0.1,0.3-0.1,0.5-0.2,0.7c-0.4,0.3-1,0.7-1.7,1.2c-3,1.8-5.8,1.8-8.8,1.9 c-3.5,0.1-6.7,0.1-10-2.1c-0.6-0.4-1-0.7-1.3-1c-0.1-0.1-0.3-0.3-0.4-0.7c-0.1-0.3,0-0.6,0-0.7c0,0-0.1,0-0.2,0.1 c-0.6,0.5-0.2,2.2-0.1,2.5c0.2,0.8,0.5,1.4,0.6,1.6c1.1,1.9,8.7,5.9,17.1,2.7c1.5-0.6,3.3-1.5,5.3-3 C29.4,338.1,29.4,336.7,29.3,335.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st21dmh",
    d: "M6.4,338.4c0.1,0.2,0.3,0.6,0.5,1c0.4,0.7,1.9,2.5,7.2,3.4c3,0.5,6.7,1.1,11-0.8c1.9-0.8,3.4-1.9,4.3-2.7 c0.8,0.5,1.1,1,1.3,1.4c0.2,0.5,0.1,1.3,0.2,1.3c0,0,0-0.1,0-0.1c0,0-0.9,6.4-1.9,13.2c-3.9,0.6-7.8,1.1-11.6,1.7 c-3.6-0.8-7.1-1.5-10.7-2.3c-0.4-4.4-0.9-8.8-1.3-13.2C5.7,340.3,6,339.4,6.4,338.4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st22dmh",
    d: "M8.3,353.7c1.6,0.5,3.2,1.1,4.8,1.6c0.3,0,0.6,0.1,0.9,0.1c1.4,0.3,2.6,0.4,3.4,0.4c1.5,0,3.5-0.2,3.5-0.2l0,0 c0,0,5.7-1.2,7.7-1.7c-0.1,0.8-0.1,1.6-0.2,2.4c-2.2,0.7-4.4,1.4-6.6,2.1c-2.8,0-5.6,0.1-8.4,0.1c-1.6-0.6-3.3-1.2-4.9-1.7 C8.3,355.8,8.3,354.7,8.3,353.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st21dmh",
    d: "M28.4,355.4c-1.4,0.7-3.1,1.4-5,1.9c-0.7,0.2-1.3,0.3-2,0.5c-1.4,0.2-2.9,0.2-4.7,0.2 c-1.3-0.1-2.6-0.2-3.7-0.4c-0.6-0.1-1.3-0.3-2.1-0.6c-0.8-0.3-1.4-0.7-1.8-1.1c0.4,3.5,0.9,7,1.3,10.5c2.5,0.5,4.9,1,7.4,1.5 c3.2-0.6,6.3-1.2,9.5-1.8C27.8,362.5,28.1,358.9,28.4,355.4z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st23dmh",
    d: "M6.5,339.3c0.1,1.2,0.1,2.4,0.2,3.5c-0.1,0.3-0.2,0.7-0.2,1c-0.1,0.7-0.1,1.3-0.2,2c-0.1-0.2-1.8-4.7-0.2-6.2 C6.1,339.5,6.3,339.4,6.5,339.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st24dmh",
    d: "M9.3,365.3c1.3,0.3,2.5,0.6,3.8,0.9c1.1,0.2,2.2,0.4,3.3,0.6c1,0,2,0,3,0.1c2.6-0.6,5.2-1.2,7.9-1.8 c0,2.5-0.1,5-0.1,7.5c-0.3,0.8-0.6,1.7-0.9,2.5c-0.7,0.2-1.4,0.3-2.1,0.5c-2.1,0.4-4.2,0.8-6.4,1.3c-2.6-0.7-5.1-1.3-7.7-2 C9.8,371.7,9.5,368.5,9.3,365.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st25dmh",
    d: "M12.1,346.3c0.6,0,1.1,0,1.7,0c0.5,10,1.1,20,1.6,30c-0.6-0.1-1.1-0.3-1.7-0.4C13.2,366,12.6,356.1,12.1,346.3 z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st25dmh",
    d: "M20.3,346.3c0.6,0,1.2,0,1.8,0c-0.4,10-0.7,19.9-1.1,29.9c-0.6,0.1-1.1,0.2-1.7,0.3 C19.7,366.5,20,356.4,20.3,346.3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st25dmh",
    d: "M27.3,345.4c0.4-0.2,0.8-0.3,1.2-0.5c-0.9,10.1-1.9,20.3-2.8,30.4c-0.4,0.1-0.9,0.2-1.3,0.3 C25.4,365.5,26.3,355.5,27.3,345.4z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st25dmh",
    d: "M6.4,343.9c0.4,0.1,0.7,0.3,1.1,0.4c1.2,10.3,2.4,20.6,3.6,30.9c-0.4-0.1-0.9-0.2-1.3-0.3 C8.6,364.5,7.5,354.2,6.4,343.9z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st23dmh",
    d: "M8.8,341.8c-0.4,0.8-0.8,1.6-1.2,2.4c1.2,10.3,2.4,20.6,3.6,30.9c0.2,0,0.5,0,0.7,0 C10.8,364,9.8,352.9,8.8,341.8z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st23dmh",
    d: "M29.4,343.4c-0.3,0.2-0.5,0.5-0.8,0.7c-1,10.4-2,20.8-3,31.2c0.4-0.1,0.5-0.2,0.5-0.2l0,0c0,0,0.2-0.5,0.2-0.5 C26.5,374.3,27.3,366.4,29.4,343.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st23dmh",
    d: "M14.6,343.4c-0.3,1-0.5,1.9-0.8,2.9c0.5,10,1.1,20,1.6,30c0.4-0.3,0.9-0.6,1.3-1C16,364.7,15.3,354,14.6,343.4 z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st23dmh",
    d: "M19.9,343.6c-0.3,0.1-0.5,0.2-0.8,0.3c-0.2,10.9-0.4,21.9-0.6,32.8c0.2-0.3,0.5-0.6,0.7-0.8 c0.3-9.8,0.7-19.7,1-29.5C20.1,345.4,20,344.5,19.9,343.6z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st23dmh",
    d: "M25.8,342.5c0.2-0.1,0.3-0.2,0.5-0.3c0.4,1.1,0.7,2.2,1.1,3.2c-1,10-2,20.1-2.9,30.1c-0.4,0-0.8,0-1.2,0 C24.1,364.5,24.9,353.5,25.8,342.5z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st26dmh",
    d: "M7.3,341.5c-0.3,0.8-0.6,1.6-0.9,2.3c0.4,0.1,0.7,0.3,1.1,0.4c0.4-0.8,0.8-1.6,1.2-2.4 C8.3,341.7,7.8,341.6,7.3,341.5z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st26dmh",
    d: "M12.4,342.9c0.7,0,1.5,0.1,2.2,0.1c-0.3,1.1-0.6,2.2-0.8,3.3c-0.6,0-1.1,0-1.7,0 C12.2,345.2,12.3,344.1,12.4,342.9z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st26dmh",
    d: "M21.9,343.4c-0.7,0.1-1.3,0.1-2,0.2c0.1,0.9,0.3,1.8,0.4,2.7c0.6,0,1.2,0,1.8,0C22,345.3,22,344.4,21.9,343.4z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st26dmh",
    d: "M27.3,345.4c0.4-0.2,0.8-0.3,1.1-0.5c-0.4-1-0.7-2.1-1.1-3.1c-0.4,0.1-0.8,0.2-1.2,0.4 C26.6,343.2,27,344.3,27.3,345.4z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st25dmh",
    d: "M29.4,340.2c-1,11.5-2,23-3,34.4c0.2-0.7,0.5-1.3,0.7-2c1.4-9.8,2.8-19.5,4.2-29.3c0-0.3,0-1.3-0.6-2.1 C30.2,340.6,29.7,340.3,29.4,340.2z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st25dmh",
    d: "M6.3,338.6c-0.4,0.3-0.9,0.8-1.1,1.5c-0.4,0.9-0.3,1.7-0.3,2.1c1.2,9.5,2.4,19,3.6,28.5 c0.3,0.5,0.6,0.9,0.9,1.4c-1.2-10-2.5-20.1-3.7-30.1c-0.1-0.2-0.1-0.7,0-1.3c0.2-0.7,0.6-1.2,0.8-1.3C6.5,339,6.4,338.8,6.3,338.6z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st7dmh",
    d: "M28.1,210.8H6.7v-12.1c0.5,0.2,1.1,0.5,2,0.8c1.4,0.5,3.1,0.9,8.3,0.9c5.6,0,7.4-0.4,8.3-0.7 c1.2-0.3,2.2-0.7,2.8-1C28.1,202.8,28.1,206.8,28.1,210.8z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st8dmh",
    d: "M27.9,207.6c-0.4,0.2-1,0.5-1.8,0.8c-1,0.4-3.2,1.1-10.2,1c-3.9-0.1-5.6-0.3-7.6-1.2c-0.6-0.2-1-0.5-1.3-0.7 c-0.1,0-0.2,0-0.2,0.1c-0.2,0.2-0.1,0.6,0.1,1.1c1.2,0.7,2.4,1.4,3.6,2c2.8,0.1,5.7,0.2,8.5,0.3c2.2-0.2,4.4-0.3,6.5-0.5 c0.8-0.6,1.6-1.2,2.3-1.7c0.3-0.6,0.3-1,0.2-1.2C28,207.6,28,207.6,27.9,207.6z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st7dmh",
    d: "M28.4,246.6c-7.2-0.1-14.5-0.2-21.7-0.3c0-12.7,0.1-25.3,0.1-38c0.6,0.4,1.5,0.9,2.6,1.4 c1.5,0.6,2.9,0.8,7.3,0.8c6.5,0,8.3-0.4,10.1-1.4c0.6-0.3,1.1-0.7,1.4-0.9C28.2,221,28.3,233.8,28.4,246.6z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 219.5,
    className: "st9dmh",
    width: 4,
    height: 8.4
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st10dmh",
    cx: 17.1,
    cy: 215.5,
    rx: 4.2,
    ry: 4.6
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11dmh",
    cx: 17.1,
    cy: 215.5,
    rx: 3.6,
    ry: 4
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st12dmh",
    cx: 18.1,
    cy: 236.2,
    rx: 5.1,
    ry: 5.3
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st13dmh",
    cx: 18.1,
    cy: 236.9,
    rx: 4.2,
    ry: 4.6
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st14dmh",
    d: "M7.3,221c0.6,0.3,1.2,0.5,1.9,0.8c0-4.2,0-8.4,0-12.6c-0.2,0-0.4,0-0.6,0c0,3.9,0,7.7,0,11.6 c-0.3-0.2-0.7-0.3-1-0.5c0-3.9,0-7.8,0.1-11.8c-0.1,0-0.2,0-0.4-0.1C7.3,212.6,7.3,216.8,7.3,221z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st15dmh",
    d: "M7.2,229.1c0,0.7,0.4,1.3,0.8,1.5c0.7,0.3,1.6-0.3,1.8-1.5c0.2-1.1,0.1-1.9,0-2.5c-0.3-1.1-1.1-2.3-1.1-2.3 c0,0,0,0,0,0c-0.2-0.2-0.5-0.6-0.8-0.5c-0.5,0.1-0.9,1-0.9,1.7C7.1,226.8,7.2,228,7.2,229.1z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st16dmh",
    d: "M6.2,226.9c0.4-1.1,1-1.7,1.5-1.6c0.1,0,0.2,0.1,0.4,0.4c0.1,0.2,0.6,1.1,0.4,2.2c-0.1,0.7-0.5,1.2-0.7,1.4 c-0.1,0-0.6,0-1-0.3c-0.5-0.4-0.6-0.9-0.6-1C6.2,227.6,6.2,227.3,6.2,226.9z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st15dmh",
    d: "M7.1,231.7c0.2-0.3,0.4-0.6,0.5-0.8c1.4,1.8,2,4,1.3,5.5c-0.1,0.3-0.4,0.7-0.8,1.1c-0.2-0.2-0.4-0.4-0.7-0.6 c0.2-0.5,0.4-1.2,0.4-2.2C7.9,233.3,7.4,232.2,7.1,231.7z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st17dmh",
    d: "M6.6,232.3c-0.3,0.5-0.7,1.5-0.5,2.7c0.1,0.5,0.1,1,0.5,1.4c0.4,0.4,0.9,0.4,1.1,0.5c0.2-0.5,0.5-1.2,0.6-2.1 c0.1-1.2,0-3-0.6-3.1C7.4,231.6,7.1,231.6,6.6,232.3z"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st18dmh",
    cx: 6.2,
    cy: 234.5,
    rx: 0.2,
    ry: 0.6
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st14dmh",
    d: "M7.4,207.9c0-1.3,0-2.6,0-3.9c0.4,0.2,0.7,0.3,1.1,0.5c0,1.4,0,2.7,0,4.1c0.2,0.1,0.4,0.1,0.6,0.2 c0-1.7,0-3.4-0.1-5.1c-0.7-0.3-1.3-0.5-2-0.8c0,1.7,0,3.3,0.1,5C7.2,207.9,7.3,207.9,7.4,207.9z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st7dmh",
    d: "M6.7,188.8h21.4v12.1c-0.5-0.2-1.1-0.5-2-0.8c-1.4-0.5-3.1-0.9-8.3-0.9c-5.6,0-7.4,0.4-8.3,0.7 c-1.2,0.3-2.2,0.7-2.8,1C6.7,196.9,6.7,192.9,6.7,188.8z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st8dmh",
    d: "M6.9,192.1c0.4-0.2,1-0.5,1.8-0.8c1-0.4,3.2-1.1,10.2-1c3.9,0.1,5.6,0.3,7.6,1.2c0.6,0.2,1,0.5,1.3,0.7 c0.1,0,0.2,0,0.2-0.1c0.2-0.2,0.1-0.6-0.1-1.1c-1.2-0.7-2.4-1.4-3.6-2c-2.8-0.1-5.7-0.2-8.5-0.3c-2.2,0.1-4.4,0.3-6.5,0.5 c-0.8,0.6-1.6,1.2-2.3,1.7c-0.3,0.6-0.3,1-0.2,1.2C6.7,192.1,6.8,192.1,6.9,192.1z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st7dmh",
    d: "M6.4,153c7.2,0.1,14.5,0.2,21.7,0.3c0,12.7-0.1,25.3-0.1,38c-0.6-0.4-1.5-0.9-2.6-1.4c-1.5-0.6-2.9-0.8-7.3-0.8 c-6.5,0-8.3,0.4-10.1,1.4c-0.6,0.3-1.1,0.7-1.4,0.9C6.6,178.7,6.5,165.8,6.4,153z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7,
    y: 171.8,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 35.3753 351.9059)",
    className: "st9dmh",
    width: 4,
    height: 8.4
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st10dmh",
    cx: 17.7,
    cy: 184.2,
    rx: 4.2,
    ry: 4.6
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11dmh",
    cx: 17.7,
    cy: 184.2,
    rx: 3.6,
    ry: 4
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st12dmh",
    cx: 16.7,
    cy: 163.5,
    rx: 5.1,
    ry: 5.3
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st13dmh",
    cx: 16.7,
    cy: 162.8,
    rx: 4.2,
    ry: 4.6
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st14dmh",
    d: "M27.5,178.7c-0.6-0.3-1.2-0.5-1.9-0.8c0,4.2,0,8.4,0,12.6c0.2,0,0.4,0,0.6,0c0-3.9,0-7.7,0-11.6 c0.3,0.2,0.7,0.3,1,0.5c0,3.9,0,7.8-0.1,11.8c0.1,0,0.2,0,0.4,0.1C27.5,187,27.5,182.9,27.5,178.7z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st15dmh",
    d: "M27.6,170.5c0-0.7-0.4-1.3-0.8-1.5c-0.7-0.3-1.6,0.3-1.8,1.5c-0.2,1.1-0.1,1.9,0,2.5c0.3,1.1,1.1,2.3,1.1,2.3 c0,0,0,0,0,0c0.2,0.2,0.5,0.6,0.8,0.5c0.5-0.1,0.9-1,0.9-1.7C27.7,172.9,27.6,171.7,27.6,170.5z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st16dmh",
    d: "M28.6,172.7c-0.4,1.1-1,1.7-1.5,1.6c-0.1,0-0.2-0.1-0.4-0.4c-0.1-0.2-0.6-1.1-0.4-2.2c0.1-0.7,0.5-1.2,0.7-1.4 c0.1,0,0.6,0,1,0.3c0.5,0.4,0.6,0.9,0.6,1C28.6,172,28.6,172.4,28.6,172.7z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st15dmh",
    d: "M27.6,167.9c-0.2,0.3-0.4,0.6-0.5,0.8c-1.4-1.8-2-4-1.3-5.5c0.1-0.3,0.4-0.7,0.8-1.1c0.2,0.2,0.4,0.4,0.7,0.6 c-0.2,0.5-0.4,1.2-0.4,2.2C26.9,166.4,27.4,167.5,27.6,167.9z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st17dmh",
    d: "M28.2,167.3c0.3-0.5,0.7-1.5,0.5-2.7c-0.1-0.5-0.1-1-0.5-1.4c-0.4-0.4-0.9-0.4-1.1-0.4 c-0.2,0.5-0.5,1.2-0.6,2.1c-0.1,1.2,0,3,0.6,3.1C27.4,168,27.7,168,28.2,167.3z"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st18dmh",
    cx: 28.6,
    cy: 165.2,
    rx: 0.2,
    ry: 0.6
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st14dmh",
    d: "M27.4,191.8c0,1.3,0,2.6,0,3.9c-0.4-0.2-0.7-0.3-1.1-0.5c0-1.4,0-2.7,0-4.1c-0.2-0.1-0.4-0.1-0.6-0.2 c0,1.7,0,3.4,0.1,5.1c0.7,0.3,1.3,0.5,2,0.8c0-1.7,0-3.3-0.1-5C27.6,191.8,27.5,191.8,27.4,191.8z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st7dmh",
    d: "M6.9,107.4h21.4v12.1c-0.5-0.2-1.1-0.5-2-0.8c-1.4-0.5-3.1-0.9-8.3-0.9c-5.6,0-7.4,0.4-8.3,0.7 c-1.2,0.3-2.2,0.7-2.8,1C6.9,115.5,6.9,111.5,6.9,107.4z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st8dmh",
    d: "M7,110.7c0.4-0.2,1-0.5,1.8-0.8c1-0.4,3.2-1.1,10.2-1c3.9,0.1,5.6,0.3,7.6,1.2c0.6,0.2,1,0.5,1.3,0.7 c0.1,0,0.2,0,0.2-0.1c0.2-0.2,0.1-0.6-0.1-1.1c-1.2-0.7-2.4-1.4-3.6-2c-2.8-0.1-5.7-0.2-8.5-0.3c-2.2,0.2-4.4,0.3-6.5,0.5 c-0.8,0.6-1.6,1.2-2.3,1.7c-0.3,0.6-0.3,1-0.2,1.2C6.9,110.7,7,110.7,7,110.7z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st7dmh",
    d: "M6.6,71.6c7.2,0.1,14.5,0.2,21.7,0.3c0,12.7-0.1,25.3-0.1,38c-0.6-0.4-1.5-0.9-2.6-1.4 c-1.5-0.6-2.9-0.8-7.3-0.8c-6.5,0-8.3,0.4-10.1,1.4c-0.6,0.3-1.1,0.7-1.4,0.9C6.8,97.3,6.7,84.5,6.6,71.6z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 90.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 35.741 189.1181)",
    className: "st9dmh",
    width: 4,
    height: 8.4
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st10dmh",
    cx: 17.8,
    cy: 102.8,
    rx: 4.2,
    ry: 4.6
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11dmh",
    cx: 17.8,
    cy: 102.8,
    rx: 3.6,
    ry: 4
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st12dmh",
    cx: 16.9,
    cy: 82.1,
    rx: 5.1,
    ry: 5.3
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st13dmh",
    cx: 16.9,
    cy: 81.4,
    rx: 4.2,
    ry: 4.6
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st14dmh",
    d: "M27.7,97.3c-0.6-0.3-1.2-0.5-1.9-0.8c0,4.2,0,8.4,0,12.6c0.2,0,0.4,0,0.6,0c0-3.9,0-7.7,0-11.6 c0.3,0.2,0.7,0.3,1,0.5c0,3.9,0,7.8-0.1,11.8c0.1,0,0.2,0,0.4,0.1C27.7,105.6,27.7,101.5,27.7,97.3z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st15dmh",
    d: "M27.8,89.1c0-0.7-0.4-1.3-0.8-1.5c-0.7-0.3-1.6,0.3-1.8,1.5c-0.2,1.1-0.1,1.9,0,2.5c0.3,1.1,1.1,2.3,1.1,2.3 c0,0,0,0,0,0c0.2,0.2,0.5,0.6,0.8,0.5c0.5-0.1,0.9-1,0.9-1.7C27.9,91.5,27.8,90.3,27.8,89.1z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st16dmh",
    d: "M28.7,91.3c-0.4,1.1-1,1.7-1.5,1.6c-0.1,0-0.2-0.1-0.4-0.4c-0.1-0.2-0.6-1.1-0.4-2.2c0.1-0.7,0.5-1.2,0.7-1.4 c0.1,0,0.6,0,1,0.3c0.5,0.4,0.6,0.9,0.6,1C28.8,90.7,28.8,91,28.7,91.3z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st15dmh",
    d: "M27.8,86.5c-0.2,0.3-0.4,0.6-0.5,0.8c-1.4-1.8-2-4-1.3-5.5c0.1-0.3,0.4-0.7,0.8-1.1c0.2,0.2,0.4,0.4,0.7,0.6 c-0.2,0.5-0.4,1.2-0.4,2.2C27.1,85,27.6,86.1,27.8,86.5z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st17dmh",
    d: "M28.4,85.9c0.3-0.5,0.7-1.5,0.5-2.7c-0.1-0.5-0.1-1-0.5-1.4c-0.4-0.4-0.9-0.4-1.1-0.4 c-0.2,0.5-0.5,1.2-0.6,2.1c-0.1,1.2,0,3,0.6,3.1C27.6,86.7,27.9,86.6,28.4,85.9z"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st18dmh",
    cx: 28.8,
    cy: 83.8,
    rx: 0.2,
    ry: 0.6
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st14dmh",
    d: "M27.6,110.4c0,1.3,0,2.6,0,3.9c-0.4-0.2-0.7-0.3-1.1-0.5c0-1.4,0-2.7,0-4.1c-0.2-0.1-0.4-0.1-0.6-0.2 c0,1.7,0,3.4,0.1,5.1c0.7,0.3,1.3,0.5,2,0.8c0-1.7,0-3.3-0.1-5C27.7,110.4,27.7,110.4,27.6,110.4z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st19dmh",
    d: "M28.2,76.8c0.1-0.1,0.3-0.3,0.4-0.6c0.1-0.2,0.1-0.4,0.1-0.5c-0.4-0.6-0.7-1.3-1.1-1.9c-2.5-0.7-5-1.5-7.5-2.2 c-3,0.2-6,0.5-9,0.7c-1.3,0.8-2.5,1.5-3.8,2.3c-0.2,0.4-0.4,0.7-0.7,1.1c0,0-0.2,0.5,0,0.9C6.6,76.8,6.9,77,6.9,77 c0.7-0.5,1.7-1.3,3.1-1.9c2.2-1,4-1,7.6-1c3.4,0,5.2,0,7.3,0.8C26.4,75.5,27.4,76.2,28.2,76.8z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st8dmh",
    d: "M6.3,201.3c5.2,0.3,18.8,0.9,21.5,0c0.4-0.1,1.3-0.4,1.4-1c0.1-0.6-1.1-1.2-1.4-1.4c-7.2,0-14.4,0-21.6,0 c-0.7,0-1.2,0.5-1.2,1.2C5.1,200.8,5.6,201.4,6.3,201.3z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st0dmh",
    d: "M0.6,12c-0.1-0.8-0.2-2.6,0.6-4.6C1.8,6,2.6,5,3.2,4.6C5,3.2,10.9-0.7,18.8,0.1c5.3,0.6,9.2,3,11.1,4.4 c0.3,0.2,1.2,0.9,1.6,2.3C32,8,31.8,9,31.8,9.5c-1.1-0.9-2.8-2.2-5-3.2c-4.2-1.9-7.9-1.9-10.1-1.9C13.3,4.5,8.8,4.6,4.5,7.9 C2.6,9.3,1.4,10.9,0.6,12z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st1dmh",
    d: "M0.4,15c-0.1-0.8-0.1-2.5,0.7-4.3c0.6-1.5,1.5-2.4,2-2.9c1.8-1.3,7.8-5.3,16-4.4c5.4,0.6,9.4,3,11.3,4.4 c0.3,0.2,1.2,0.9,1.6,2.3c0.4,1.2,0.3,2.2,0.2,2.6c-1.2-0.9-2.9-2.2-5.1-3.2c-4.3-1.9-8-1.9-10.3-1.9C13.7,7.8,9,7.9,4.4,11.2 C2.5,12.5,1.2,14,0.4,15z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st2dmh",
    d: "M0.3,19.7c-0.2-0.6-0.7-2.8,0.2-5.2c0.6-1.5,1.6-2.5,2.1-2.9c1.9-1.3,8.2-5.3,16.6-4.4c5.6,0.6,9.7,3,11.8,4.4 c0.6,0.4,1.3,1.1,1.7,2.3c0.7,2-0.1,4.1-0.4,4.8c-0.9-1.4-2.5-3.4-4.9-5c-3.5-2.2-6.7-2.2-10.4-2.2c-4.4,0-9,0-12.9,3.4 C2.2,16.5,1,18.4,0.3,19.7z"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3dmh",
    cx: 16.4,
    cy: 19.9,
    rx: 16.1,
    ry: 8.9
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st4dmh",
    d: "M4.6,21c0-0.5-0.1-1.7,0.5-2.9c0.4-1,1.1-1.6,1.5-2c1.3-0.9,5.7-3.6,11.6-3c3.9,0.4,6.8,2,8.2,3 c0.2,0.2,0.9,0.6,1.2,1.5c0.3,0.8,0.2,1.5,0.2,1.8c-0.8-0.6-2.1-1.5-3.7-2.1c-3.1-1.3-5.8-1.3-7.4-1.3c-2.2,0-5.7,0.1-9,2.3 C6.2,19.3,5.2,20.3,4.6,21z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st5dmh",
    d: "M4.6,24.2c-0.1-0.4-0.5-1.9,0.2-3.6c0.4-1,1.1-1.7,1.5-2c1.4-0.9,5.9-3.6,12-3c4.1,0.4,7,2,8.5,3 c0.4,0.3,0.9,0.8,1.2,1.5c0.5,1.4,0,2.8-0.3,3.2c-0.7-0.9-1.8-2.3-3.6-3.4c-2.5-1.5-4.8-1.5-7.5-1.5c-3.2,0-6.5,0-9.4,2.3 C5.9,22,5.1,23.3,4.6,24.2z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st6dmh",
    d: "M4.4,26.7c-0.1-0.4-0.5-1.9,0.2-3.6c0.4-1,1.1-1.7,1.5-2c1.4-0.9,5.9-3.6,12-3c4.1,0.4,7,2,8.5,3 c0.4,0.3,0.9,0.8,1.2,1.5c0.5,1.4,0,2.8-0.3,3.2C27,25,25.8,23.7,24,22.6c-2.5-1.5-4.8-1.5-7.5-1.5c-3.2,0-6.5,0-9.4,2.3 C5.8,24.6,4.9,25.8,4.4,26.7z"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3dmh",
    cx: 16,
    cy: 26.8,
    rx: 12.5,
    ry: 6.3
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st19dmh",
    d: "M27.7,77.1c0.1-0.1,0.3-0.3,0.4-0.6c0.1-0.2,0.1-0.4,0.1-0.5c-0.4-0.6-0.7-1.3-1.1-1.9c-2.5-0.7-5-1.5-7.5-2.2 c-3,0.2-6,0.5-9,0.7c-1.3,0.8-2.5,1.5-3.8,2.3c-0.2,0.4-0.4,0.7-0.7,1.1c0,0-0.2,0.5,0,0.9c0.1,0.3,0.4,0.4,0.4,0.5 c0.7-0.5,1.7-1.3,3.1-1.9c2.2-1,4-1,7.6-1c3.4,0,5.2,0,7.3,0.8C25.9,75.8,27,76.6,27.7,77.1z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st20dmh",
    d: "M28.2,76c-0.4-0.5-1.1-1.2-2-1.9c-1-0.7-2.6-1.5-8.6-1.5c-5.8,0-7.4,0.7-8.2,1.1c-1.5,0.7-2.5,1.6-3.2,2.3 C6,72.2,5.8,68.4,5.7,64.7c0.2-1.1,0.3-2.2,0.5-3.4c2.4-0.9,4.8-1.7,7.1-2.6c4,0.4,7.9,0.9,11.9,1.3c1.1,1.1,2.3,2.2,3.4,3.4 c-0.1,0.3-0.2,0.7-0.3,1C28.2,68.2,28.2,72.1,28.2,76z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st19dmh",
    d: "M5.7,64.7c0-0.3,0.1-0.6,0.2-1c0.1-0.3,0.1-0.5,0.2-0.7c0.4-0.3,1-0.7,1.7-1.2c3-1.8,5.8-1.8,8.8-1.9 c3.5-0.1,6.7-0.1,10,2.1c0.6,0.4,1,0.7,1.3,1c0.1,0.1,0.3,0.3,0.4,0.7c0.1,0.3,0,0.6,0,0.7c0,0,0.1,0,0.2-0.1 c0.6-0.5,0.2-2.2,0.1-2.5c-0.2-0.8-0.5-1.4-0.6-1.6c-1.1-1.9-8.7-5.9-17.1-2.7c-1.5,0.6-3.3,1.5-5.3,3C5.6,61.9,5.6,63.3,5.7,64.7z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st21dmh",
    d: "M28.6,61.6c-0.1-0.2-0.3-0.6-0.5-1c-0.4-0.7-1.9-2.5-7.2-3.4c-3-0.5-6.7-1.1-11,0.8c-1.9,0.8-3.4,1.9-4.3,2.7 c-0.8-0.5-1.1-1-1.3-1.4C4.1,58.8,4.2,58,4.2,58c0,0,0,0.1,0,0.1c0,0,0.9-6.4,1.9-13.2c3.9-0.6,7.8-1.1,11.6-1.7 c3.6,0.8,7.1,1.5,10.7,2.3c0.4,4.4,0.9,8.8,1.3,13.2C29.3,59.7,29,60.6,28.6,61.6z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st22dmh",
    d: "M26.7,46.3c-1.6-0.5-3.2-1.1-4.8-1.6c-0.3,0-0.6-0.1-0.9-0.1c-1.4-0.3-2.6-0.4-3.4-0.4c-1.5,0-3.5,0.2-3.5,0.2 l0,0c0,0-5.7,1.2-7.7,1.7c0.1-0.8,0.1-1.6,0.2-2.4c2.2-0.7,4.4-1.4,6.6-2.1c2.8,0,5.6-0.1,8.4-0.1c1.6,0.6,3.3,1.2,4.9,1.7 C26.7,44.2,26.7,45.3,26.7,46.3z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st21dmh",
    d: "M6.6,44.6c1.4-0.7,3.1-1.4,5-1.9c0.7-0.2,1.3-0.3,2-0.5c1.4-0.2,2.9-0.2,4.7-0.2c1.3,0.1,2.6,0.2,3.7,0.4 c0.6,0.1,1.3,0.3,2.1,0.6c0.8,0.3,1.4,0.7,1.8,1.1c-0.4-3.5-0.9-7-1.3-10.5c-2.5-0.5-4.9-1-7.4-1.5c-3.2,0.6-6.3,1.2-9.5,1.8 C7.2,37.5,6.9,41.1,6.6,44.6z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st23dmh",
    d: "M28.5,60.7c-0.1-1.2-0.1-2.4-0.2-3.5c0.1-0.3,0.2-0.7,0.2-1c0.1-0.7,0.1-1.3,0.2-2c0.1,0.2,1.8,4.7,0.2,6.2 C28.9,60.5,28.7,60.6,28.5,60.7z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st24dmh",
    d: "M25.7,34.7c-1.3-0.3-2.5-0.6-3.8-0.9c-1.1-0.2-2.2-0.4-3.3-0.6c-1,0-2,0-3-0.1c-2.6,0.6-5.2,1.2-7.9,1.8 c0-2.5,0.1-5,0.1-7.5c0.3-0.8,0.6-1.7,0.9-2.5c0.7-0.2,1.4-0.3,2.1-0.5c2.1-0.4,4.2-0.8,6.4-1.3c2.6,0.7,5.1,1.3,7.7,2 C25.2,28.3,25.5,31.5,25.7,34.7z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st25dmh",
    d: "M22.9,53.7c-0.6,0-1.1,0-1.7,0c-0.5-10-1.1-20-1.6-30c0.6,0.1,1.1,0.3,1.7,0.4C21.8,34,22.4,43.9,22.9,53.7z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st25dmh",
    d: "M14.7,53.7c-0.6,0-1.2,0-1.8,0c0.4-10,0.7-19.9,1.1-29.9c0.6-0.1,1.1-0.2,1.7-0.3C15.3,33.5,15,43.6,14.7,53.7 z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st25dmh",
    d: "M7.7,54.6c-0.4,0.2-0.8,0.3-1.2,0.5C7.5,45,8.4,34.9,9.3,24.7c0.4-0.1,0.9-0.2,1.3-0.3 C9.6,34.5,8.7,44.5,7.7,54.6z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st25dmh",
    d: "M28.6,56.1c-0.4-0.1-0.7-0.3-1.1-0.4c-1.2-10.3-2.4-20.6-3.6-30.9c0.4,0.1,0.9,0.2,1.3,0.3 C26.4,35.5,27.5,45.8,28.6,56.1z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st23dmh",
    d: "M26.2,58.2c0.4-0.8,0.8-1.6,1.2-2.4c-1.2-10.3-2.4-20.6-3.6-30.9c-0.2,0-0.5,0-0.7,0 C24.2,36,25.2,47.1,26.2,58.2z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st23dmh",
    d: "M5.6,56.6c0.3-0.2,0.5-0.5,0.8-0.7c1-10.4,2-20.8,3-31.2c-0.4,0.1-0.5,0.2-0.5,0.2l0,0c0,0-0.2,0.5-0.2,0.5 C8.5,25.7,7.7,33.6,5.6,56.6z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st23dmh",
    d: "M20.4,56.6c0.3-1,0.5-1.9,0.8-2.9c-0.5-10-1.1-20-1.6-30c-0.4,0.3-0.9,0.6-1.3,1C19,35.3,19.7,46,20.4,56.6z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st23dmh",
    d: "M15.1,56.4c0.3-0.1,0.5-0.2,0.8-0.3c0.2-10.9,0.4-21.9,0.6-32.8c-0.2,0.3-0.5,0.6-0.7,0.8 c-0.3,9.8-0.7,19.7-1,29.5C14.9,54.6,15,55.5,15.1,56.4z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st23dmh",
    d: "M9.2,57.5c-0.2,0.1-0.3,0.2-0.5,0.3c-0.4-1.1-0.7-2.2-1.1-3.2c1-10,2-20.1,2.9-30.1c0.4,0,0.8,0,1.2,0 C10.9,35.5,10.1,46.5,9.2,57.5z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st26dmh",
    d: "M27.7,58.5c0.3-0.8,0.6-1.6,0.9-2.3c-0.4-0.1-0.7-0.3-1.1-0.4c-0.4,0.8-0.8,1.6-1.2,2.4 C26.7,58.3,27.2,58.4,27.7,58.5z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st26dmh",
    d: "M22.6,57.1c-0.7,0-1.5-0.1-2.2-0.1c0.3-1.1,0.6-2.2,0.8-3.3c0.6,0,1.1,0,1.7,0C22.8,54.8,22.7,55.9,22.6,57.1z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st26dmh",
    d: "M13.1,56.6c0.7-0.1,1.3-0.2,2-0.2c-0.1-0.9-0.3-1.8-0.4-2.7c-0.6,0-1.2,0-1.8,0C13,54.7,13,55.6,13.1,56.6z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st26dmh",
    d: "M7.7,54.6c-0.4,0.2-0.8,0.3-1.1,0.5c0.4,1,0.7,2.1,1.1,3.1C8,58.1,8.4,58,8.7,57.8C8.4,56.8,8,55.7,7.7,54.6z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st25dmh",
    d: "M5.6,59.8c1-11.5,2-23,3-34.4c-0.2,0.7-0.5,1.3-0.7,2c-1.4,9.8-2.8,19.5-4.2,29.3c0,0.3,0,1.3,0.6,2.1 C4.8,59.4,5.3,59.7,5.6,59.8z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st25dmh",
    d: "M28.7,61.4c0.4-0.3,0.9-0.8,1.1-1.5c0.4-0.9,0.3-1.7,0.3-2.1c-1.2-9.5-2.4-19-3.6-28.5 c-0.3-0.5-0.6-0.9-0.9-1.4c1.2,10,2.5,20.1,3.7,30.1c0.1,0.2,0.1,0.7,0,1.3c-0.2,0.7-0.6,1.2-0.8,1.3C28.5,61,28.6,61.2,28.7,61.4z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st8dmh",
    d: "M6.6,240.5c0,0.1,0,0.2,0.1,0.3c0.7,2,3.8,1.9,11.2,2c6.6,0.1,9.4,0.1,10.1-1.7c0.1-0.4,0.2-0.8,0.1-1.1 c0.9,0,1.6,0.8,1.6,1.7c0.1,1-0.6,2.1-1.6,2.1c-0.6,0.3-1.5,0.7-2.6,1c-1.8,0.5-2.6,0.3-8.6,0.2c0,0-1.7,0-4.8-0.2 c-1-0.1-1.9-0.1-2.5-0.2c-1.9-0.2-2.5-0.4-3-0.7c-0.6-0.4-1.5-0.9-1.5-1.7C5.1,241.5,5.7,240.8,6.6,240.5z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st7dmh",
    d: "M6.3,143.3h21.9v10.6c-7.2-0.1-14.5-0.1-21.7-0.2C6.5,150.3,6.4,146.8,6.3,143.3z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.8,
    y: 118,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 34.0281 259.7572)",
    className: "st14dmh",
    width: 16.4,
    height: 23.8
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14dmh",
    cx: 17.2,
    cy: 128.2,
    rx: 11.4,
    ry: 1.3
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7dmh",
    cx: 17.2,
    cy: 125.6,
    rx: 11.4,
    ry: 1.3
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14dmh",
    cx: 17.3,
    cy: 122.9,
    rx: 11.4,
    ry: 1.3
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7dmh",
    cx: 17.1,
    cy: 120.5,
    rx: 11.4,
    ry: 1.3
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14dmh",
    cx: 17.4,
    cy: 138.2,
    rx: 11.4,
    ry: 1.3
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7dmh",
    cx: 17.3,
    cy: 135.9,
    rx: 11.4,
    ry: 1.3
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14dmh",
    cx: 17.4,
    cy: 133.2,
    rx: 11.4,
    ry: 1.3
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7dmh",
    cx: 17.2,
    cy: 130.8,
    rx: 11.4,
    ry: 1.3
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7dmh",
    cx: 17.7,
    cy: 140.5,
    rx: 11.4,
    ry: 1.3
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st8dmh",
    d: "M28.4,146c0-0.1,0-0.2-0.1-0.3c-0.7-2-3.9-1.9-11.5-2c-6.8-0.1-9.7-0.1-10.4,1.7c-0.2,0.4-0.2,0.8-0.2,1.1 c-0.9,0-1.6-0.8-1.7-1.7c-0.1-1,0.7-2.1,1.7-2.1c0.6-0.3,1.5-0.7,2.7-1c1.8-0.5,2.6-0.3,8.8-0.2c0,0,1.8,0,4.9,0.2 c1,0.1,1.9,0.1,2.5,0.2c1.9,0.2,2.5,0.4,3.1,0.7c0.6,0.4,1.5,0.9,1.5,1.7C29.9,145,29.3,145.7,28.4,146z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st8dmh",
    d: "M28.3,159.1c0-0.1,0-0.2-0.1-0.3c-0.7-2-3.8-1.9-11.2-2c-6.6-0.1-9.4-0.1-10.1,1.7c-0.1,0.4-0.2,0.8-0.1,1.1 c-0.9,0-1.6-0.8-1.6-1.7c-0.1-1,0.6-2.1,1.6-2.1c0.6-0.3,1.5-0.7,2.6-1c1.8-0.5,2.6-0.3,8.6-0.2c0,0,1.7,0,4.8,0.2 c1,0.1,1.9,0.1,2.5,0.2c1.9,0.2,2.5,0.4,3,0.7c0.6,0.4,1.5,0.9,1.5,1.7C29.8,158.1,29.2,158.8,28.3,159.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarthMaulHilt);
export default __webpack_public_path__ + "static/media/darth-maul-hilt.72bb9aba.svg";
export { ForwardRef as ReactComponent };